var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "116px",
    viewBox: "0 0 104 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---post---0",
    transform: "translate(-1199.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newest",
    transform: "translate(1061.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(138.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F5F6FA",
    points: "96.5602699 0 104 108.223673 4.73188215 115.226667 0 46.4043786 36.7464291 4.21845368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EEEFF3",
    points: "36.3220686 4.64 39 44.3672614 0 47.1733333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(53.788380, 72.637913) rotate(1.000000) translate(-53.788380, -72.637913) translate(15.288380, 54.137913)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.17879436,
    y1: 19.3615472,
    x2: 75.3717535,
    y2: 19.3035396,
    id: "Path",
    transform: "translate(38.275274, 19.332543) rotate(-5.000000) translate(-38.275274, -19.332543) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.98811843,
    y1: 26.2470258,
    x2: 76.1810775,
    y2: 26.1890183,
    id: "Path",
    transform: "translate(39.084598, 26.218022) rotate(-5.000000) translate(-39.084598, -26.218022) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.070725703,
    y1: 3.84410067,
    x2: 74.2636848,
    y2: 3.78609312,
    id: "Path",
    transform: "translate(37.167205, 3.815097) rotate(-5.000000) translate(-37.167205, -3.815097) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.349553991,
    y1: 11.900604,
    x2: 74.5425131,
    y2: 11.8425965,
    id: "Path",
    transform: "translate(37.446034, 11.871600) rotate(-5.000000) translate(-37.446034, -11.871600) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.25998416,
    y1: 34.3863213,
    x2: 38.2150336,
    y2: 34.3582099,
    id: "Path",
    transform: "translate(20.237509, 34.372266) rotate(-5.000000) translate(-20.237509, -34.372266) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPage);
export default __webpack_public_path__ + "static/media/documentPage.d961791679deea6985684a2983e79e25.svg";
export { ForwardRef as ReactComponent };